import { handleActions } from 'redux-actions';

export const initialState = null;

const onSuccess = (state, action) => {
  return {
    ...action.payload,
  };
};

/* 
TODO: Currenlty there is no claer way to get `GET_NEWSLETTER_SUCCESS` imported from actions due to
`createHttpAction` returns only the warpper function `getNewsletterSuccess`,
but not the actual `success` function created by createActions.

Thus currently I need to hard code `GET_NEWSLETTER_SUCCESS` in the handleActions Map
below, but we need to reimplement Pantheon to expose the success function that 
can be passed to the handleActions Map.
*/
const newsletter = handleActions(
  new Map([[`GET_NEWSLETTER_SUCCESS`, onSuccess]]),
  initialState,
);


export default newsletter;
